import React from "react";

import Grid from "@material-ui/core/Grid";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import TopLeftCorner from "../../shared-components/TopLeftCorner";
import TopRightCorner from "../../shared-components/TopRightCorner";
import BottomLeftCorner from "../../shared-components/BottomLeftCorner";
import BottomRightCorner from "../../shared-components/BottomRightCorner";

import ContactOptionsList from "./ContactOptionsList";

const Contact = () => {
  const matchesSm = useMediaQuery("(max-width:1280px)");

  return (
    <Grid container style={{ padding: "2.5rem", color: "#EEEEEE" }}>
      <Grid item>
        <TopLeftCorner />
        <Grid container alignItems="flex-end" style={{ height: "92.5%" }}>
          <BottomLeftCorner />
        </Grid>
      </Grid>

      <Grid item lg md sm xs style={{ margin: "3rem 0" }}>
        <h1 style={{ marginBottom: "6rem" }} className="contact-title">
          # Have a{" "}
          <span
            style={{
              padding: "0.2rem 0.5rem 0.3rem",
              color: "#222831",
              backgroundColor: "#EEEEEE",
            }}
          >
            project
          </span>{" "}
          you'd like to discuss?
        </h1>

        <ContactOptionsList />
      </Grid>

      <Grid
        item
        style={matchesSm ? { display: "none" } : { margin: "7.5rem 0" }}
      >
        <TopRightCorner color="#A1A5FF" animate="corner-3" />
        <div
          style={{
            width: "6px",
            height: "54%",
            margin: "3rem 0 3rem 2.5rem",
            backgroundColor: "#A1A5FF",
          }}
          className="vertical-bar-3"
        ></div>
        <Grid container alignItems="flex-end" className="corner-1">
          <BottomRightCorner color="#A1A5FF" />
        </Grid>
      </Grid>

      <Grid item style={matchesSm ? { display: "none" } : { margin: "5rem 0" }}>
        <TopRightCorner color="#FFE665" animate="corner-2" />
        <div
          style={{
            width: "6px",
            height: "62%",
            margin: "3rem 0 3rem 2.5rem",
            backgroundColor: "#FFE665",
          }}
          className="vertical-bar-2"
        ></div>
        <Grid container alignItems="flex-end" className="corner-2">
          <BottomRightCorner color="#FFE665" />
        </Grid>
      </Grid>

      <Grid
        item
        style={matchesSm ? { display: "none" } : { margin: "2.5rem 0 " }}
      >
        <TopRightCorner color="#5FEAFD" animate="corner-1" />
        <div
          style={{
            width: "6px",
            height: "68%",
            margin: "3rem 0 3rem 2.5rem",
            backgroundColor: "#5FEAFD",
          }}
          className="vertical-bar-1"
        ></div>
        <Grid container alignItems="flex-end" className="corner-3">
          <BottomRightCorner color="#5FEAFD" />
        </Grid>
      </Grid>

      <Grid item>
        <TopRightCorner />
        <div
          style={{
            width: "6px",
            height: "72%",
            margin: "3rem 0 3rem 2.5rem",
            backgroundColor: "#EEEEEE",
          }}
        ></div>
        <Grid container alignItems="flex-end">
          <BottomRightCorner />
        </Grid>
      </Grid>
    </Grid>
  );
};

export default Contact;
